import { createFileRoute } from "@tanstack/react-router";
import AppCard from "@/components/AppCard.tsx";
import CampaignsDataGrid from "@/components/campaigns/datagrid/CampaignsDataGrid.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/campaigns/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppCard title={"Campagnes"}>
      <CampaignsDataGrid />
    </AppCard>
  );
}
